export default "__VITE_ASSET__Db_i8hC1__"